import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useContext } from 'react';
import { Settings } from '../../../../../settings/SettingsContext';
import { useExportDataBl } from '../../ExportData.bl';
import { IExportDataStore } from '../../ExportData.store';
import { ProjectExportsTable } from './ProjectExportsTable';

export const ProjectExportsTableContainer = observer((): ReactElement => {
  const store = useInjection(IExportDataStore.$);
  const bl = useExportDataBl();

  const settingsContext = useContext(Settings);

  const handleOrderingChange = async (orderBy: string, orderType: string): Promise<void> => {
    await bl.changeOrderAsync(orderBy, orderType);
  };

  const handlePaginationChange = async (pageNumber: number, pageSize: number): Promise<void> => {
    settingsContext.setProjectsExportsPageSize(pageSize);
    await bl.changePaginationAsync(pageNumber, pageSize);
  };

  return (
    <ProjectExportsTable
      isLoading={store.showLoader}
      items={store.projectExports}
      onOrderingChange={handleOrderingChange}
      onPaginationChange={handlePaginationChange}
      paging={{ ...store.paging, pageSize: settingsContext.store.projectsExportsPageSize }}
    />
  );
});
